import React from "react";
import { useLang } from "@/i18n/LangContext";

/* Vector logos for tech stack (simple, recognizable, brand-accurate) */
const Logos = {
  whatsapp: (
    <svg viewBox="0 0 32 32" className="w-7 h-7" fill="currentColor" aria-hidden="true">
      <path d="M16 .395c-8.836 0-16 7.163-16 16 0 2.81.726 5.557 2.103 7.97L.063 31.6l7.466-1.957a15.92 15.92 0 0 0 8.471 2.418h.001c8.836 0 16-7.163 16-16 0-4.275-1.665-8.295-4.687-11.318C24.292 2.06 20.272.395 15.999.395Zm0 29.366h-.001a13.31 13.31 0 0 1-6.781-1.856l-.486-.289-5.043 1.323 1.347-4.916-.317-.504a13.297 13.297 0 0 1-2.04-7.124c0-7.346 5.978-13.32 13.323-13.32 3.558 0 6.901 1.387 9.418 3.904a13.252 13.252 0 0 1 3.902 9.42c0 7.347-5.978 13.32-13.322 13.32Zm7.314-9.971c-.4-.2-2.37-1.17-2.738-1.302-.367-.134-.634-.2-.9.2s-1.033 1.301-1.267 1.568c-.234.267-.467.3-.867.1-.4-.2-1.69-.622-3.22-1.987-1.19-1.06-1.992-2.37-2.226-2.77-.234-.4-.025-.616.175-.815.18-.18.4-.467.6-.7.2-.234.267-.4.4-.667.134-.267.067-.5-.033-.7-.1-.2-.9-2.167-1.233-2.967-.324-.78-.654-.674-.9-.687-.233-.011-.5-.014-.766-.014-.267 0-.7.1-1.067.5-.367.4-1.4 1.367-1.4 3.334 0 1.967 1.434 3.867 1.633 4.134.2.267 2.819 4.305 6.829 6.038.954.412 1.698.658 2.279.843.957.305 1.828.262 2.517.159.768-.115 2.37-.97 2.704-1.905.334-.937.334-1.74.234-1.905-.1-.166-.367-.267-.767-.467Z"/>
    </svg>
  ),
  google: (
    <svg viewBox="0 0 24 24" className="w-7 h-7" aria-hidden="true">
      <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09Z"/>
      <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.99.66-2.26 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A10.997 10.997 0 0 0 12 23Z"/>
      <path fill="#FBBC04" d="M5.84 14.1c-.22-.66-.35-1.36-.35-2.1 0-.74.13-1.44.35-2.1V7.07H2.18a11.002 11.002 0 0 0 0 9.86l3.66-2.83Z"/>
      <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.2 1.64l3.15-3.15C17.46 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38Z"/>
    </svg>
  ),
  openai: (
    <svg viewBox="0 0 24 24" className="w-7 h-7" fill="currentColor" aria-hidden="true">
      <path d="M22.282 9.821a5.985 5.985 0 0 0-.516-4.91 6.046 6.046 0 0 0-6.51-2.9A6.065 6.065 0 0 0 4.981 4.18a5.985 5.985 0 0 0-3.998 2.9 6.046 6.046 0 0 0 .743 7.097 5.98 5.98 0 0 0 .51 4.911 6.051 6.051 0 0 0 6.515 2.9A5.985 5.985 0 0 0 13.26 24a6.056 6.056 0 0 0 5.772-4.206 5.99 5.99 0 0 0 3.997-2.9 6.056 6.056 0 0 0-.747-7.073ZM13.26 22.43a4.476 4.476 0 0 1-2.876-1.04l.141-.081 4.779-2.758a.795.795 0 0 0 .392-.681v-6.737l2.02 1.168a.071.071 0 0 1 .038.052v5.583a4.504 4.504 0 0 1-4.494 4.494ZM3.6 18.304a4.47 4.47 0 0 1-.535-3.014l.142.085 4.783 2.759a.771.771 0 0 0 .78 0l5.843-3.369v2.332a.08.08 0 0 1-.033.062L9.74 19.95a4.5 4.5 0 0 1-6.14-1.646ZM2.34 7.896a4.485 4.485 0 0 1 2.366-1.973V11.6a.766.766 0 0 0 .388.676l5.815 3.355-2.02 1.168a.076.076 0 0 1-.071 0l-4.83-2.786A4.504 4.504 0 0 1 2.34 7.872Zm16.597 3.855-5.833-3.387L15.119 7.2a.076.076 0 0 1 .071 0l4.83 2.791a4.494 4.494 0 0 1-.676 8.105v-5.678a.79.79 0 0 0-.407-.667Zm2.01-3.023-.141-.085-4.774-2.782a.776.776 0 0 0-.785 0L9.409 9.23V6.897a.066.066 0 0 1 .033-.061l4.829-2.787a4.5 4.5 0 0 1 6.68 4.66Zm-12.64 4.135-2.02-1.164a.08.08 0 0 1-.038-.057V6.075a4.5 4.5 0 0 1 7.375-3.453l-.142.08L8.704 5.46a.795.795 0 0 0-.393.681Zm1.097-2.365 2.602-1.5 2.607 1.5v3l-2.597 1.5-2.607-1.5Z"/>
    </svg>
  ),
  claude: (
    <svg viewBox="0 0 24 24" className="w-7 h-7" fill="currentColor" aria-hidden="true">
      <path d="M5.36 18.27 9.16 15.3l.06-.18-.06-.1H8.97L8.35 15l-3.74-.05-3.24-.04L1.27 14.7l-.32-.46.03-.21.27-.4 4.74-.06 4.04-.05 3.16-.14L19.7 13l1.46-.18.85.36.21.13-.08.22-.31.34-2.62 1.79-3.79 2.32-4.42 2.66-1.27.78-1.55.96-.78-.06-.71-.7.4-.55Zm10.97-7.55 2.86-1.78 1.51-.95.27.04.18.33-.07.21-.27.27L17.7 11.4l-4.84 2.93-.69.07-.07-.07.07-.19 3.16-3.41 1-.01Zm-3.86 8.21-2.86-3.16-.07-.16.04-.13.59-.07 6.36 1.66 1.97.48.69.21.07.16-.32.4-.77.05-1.66-.21-3.18-.95-.86-.31Zm-2.36-9.83 1.66-.06.05.06.21.21 1.55 1.5 2.04 1.66.86.71.13.21-.04.13-.43.04-1.04-.13-1.95-.71-1.39-.55-.66-.55-1.66-1.83-.07-.21.78-.48Zm.42-2.84 1.27-.04.27.07 1.83 1.04 1.04.83 1.45 1.04.66.48.27.34-.07.13-.71.04-1.45-.21-1.83-.69-1.66-.78-1.04-.78-.27-.41.24-1.07Z"/>
    </svg>
  ),
  stripe: (
    <svg viewBox="0 0 24 24" className="w-7 h-7" fill="currentColor" aria-hidden="true">
      <path d="M13.479 9.883c-1.626-.604-2.512-1.067-2.512-1.803 0-.622.511-.977 1.423-.977 1.667 0 3.379.642 4.558 1.221l.666-4.111c-.935-.446-2.847-1.179-5.49-1.179-1.87 0-3.425.488-4.536 1.401-1.155.954-1.757 2.334-1.757 4 0 3.023 1.846 4.312 4.86 5.408 1.953.701 2.606 1.197 2.606 1.954 0 .732-.628 1.151-1.766 1.151-1.451 0-3.847-.712-5.427-1.622l-.679 4.165c1.346.762 3.823 1.526 6.396 1.526 1.978 0 3.625-.469 4.74-1.357 1.244-.989 1.889-2.443 1.889-4.317 0-3.099-1.892-4.395-4.971-5.519l-.001.059Z"/>
    </svg>
  ),
  calcom: (
    <svg viewBox="0 0 24 24" className="w-7 h-7" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
      <rect x="3" y="5" width="18" height="16" rx="2.5" />
      <line x1="3" y1="10" x2="21" y2="10" />
      <line x1="8" y1="3" x2="8" y2="7" strokeLinecap="round" />
      <line x1="16" y1="3" x2="16" y2="7" strokeLinecap="round" />
      <circle cx="8" cy="14.5" r="1.1" fill="currentColor" />
      <circle cx="12" cy="14.5" r="1.1" fill="currentColor" />
      <circle cx="16" cy="14.5" r="1.1" fill="currentColor" />
    </svg>
  ),
  vercel: (
    <svg viewBox="0 0 24 24" className="w-7 h-7" fill="currentColor" aria-hidden="true">
      <path d="M12 2 2 20h20L12 2Z" />
    </svg>
  ),
};

const PoweredBy = () => {
  const { t } = useLang();
  const pb = t.powered_by;

  // Map items to logos with brand colors
  const cards = [
    { ...pb.items[0], logo: Logos.whatsapp, color: "#25D366" },
    { ...pb.items[1], logo: <span className="flex gap-1 items-center">{Logos.openai}<span className="w-px h-5 bg-white/20" />{Logos.claude}</span>, color: "#10A37F" },
    { ...pb.items[2], logo: Logos.google, color: "#4285F4" },
    { ...pb.items[3], logo: Logos.stripe, color: "#635BFF" },
    { ...pb.items[4], logo: Logos.calcom, color: "#00E5A0" },
    { ...pb.items[5], logo: Logos.vercel, color: "#FFFFFF" },
  ];

  return (
    <section className="py-20 lg:py-28 relative" data-testid="powered-by-section">
      <div className="max-w-7xl mx-auto px-5">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-[#00E5A0] mb-4">
            — {pb.eyebrow}
          </div>
          <h2 className="font-display font-extrabold text-[clamp(1.8rem,3.8vw,2.8rem)] leading-[1.05] tracking-tight mb-4">
            {pb.title_a} <span className="text-[#00E5A0]">{pb.title_h}</span>{pb.title_b}
          </h2>
          <p className="text-base text-[#F5F7FA]/60">{pb.subtitle}</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
          {cards.map((c, i) => (
            <div
              key={i}
              data-testid={`powered-by-card-${i}`}
              className="group relative zk-glass rounded-2xl p-5 hover:border-[#00E5A0]/40 transition-all cursor-default"
            >
              <div
                className="mb-3 transition-transform group-hover:scale-110 origin-left inline-block"
                style={{ color: c.color }}
              >
                {c.logo}
              </div>
              <div className="font-display font-bold text-sm text-white leading-tight mb-1">
                {c.name}
              </div>
              <div className="text-[11px] text-[#6B7A8D] leading-snug">
                {c.desc}
              </div>
              {/* Subtle brand accent stripe */}
              <div
                className="absolute bottom-0 left-5 right-5 h-px opacity-0 group-hover:opacity-60 transition-opacity"
                style={{ background: c.color }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PoweredBy;
